import axios from 'axios'

// TODO this function is being called from 2 places(approveConsultation and ReviewPrescription, make sure fax is not sent twice
// TODO would be if show an alert in case of failure to send fax

export const sendAuthorizedPrescription = async (delegateConvoObj = {}) => {

  try {
    const {patientID, id, originalPrescriptionPDF,pharmacy = {}, prescriptionData = {} } = delegateConvoObj;
    const { authorization  = {}} = prescriptionData;
    const authorizationValues = Object.values(authorization);
    let requireAuth = false;
    for (let i = 0; i < authorizationValues.length; i++) {
      if (authorizationValues[i] === 'true') {
        requireAuth = true;
        break;
      }
    }
    if (requireAuth){
      const payload = {
        patientID: patientID || null,
        country: delegateConvoObj.country,
        chatID: id || null,
        perscription_url: originalPrescriptionPDF || null,
        fax_number: pharmacy?.fax_number || null,
      }
      if (payload?.perscription_url && payload?.fax_number && payload?.chatID) {
        const response = await axios({
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL}/sendPrescriptionFax`,
          data: JSON.stringify(payload)
        });
        console.log('sendPrescriptionFax response', response)
      }
    }
    }

  catch (e) {
    console.log('error', e)
  }

}
